<div class="wrapper">
  <h1 class="poster-font">404</h1>
  <h5>{{ 'notFound.subtitle' | translate }}</h5>
  <p>{{ 'notFound.description' | translate }}</p>

  <button color="primary" mat-flat-button routerLink="/home">
    {{ 'notFound.goHome' | translate }}
  </button>
</div>
